import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { fetchWrapper } from "../_helpers";

// create slice

const name = "home";
const initialState = createInitialState();
const reducers = createReducers();
const extraActions = createExtraActions();
// const extraReducers = createExtraReducers();
const slice = createSlice({
  name,
  initialState,
  reducers,
  extraReducers: (builder) => {
    createExtraReducers(builder);
  },
  // extraReducers,
});

// exports

export const homePageActions = { ...slice.actions, ...extraActions };
export const homePageReducer = slice.reducer;

// implementation
function createInitialState() {
  return {
    homePageContentResponse: {},
    homePageIntegrationResponse: {},
    loading: false,
    textEditorTemplate:[]
  };
}

function createReducers() {
  return {
    updateHomePageResponse,
    resetHomePageData,
    setHomePageData
    
  };
  function updateHomePageResponse(state, action) {
    state.homePageContentResponse.data = action?.payload;
    debugger;
  }

  function resetHomePageData(state, action) {
    state.homePageContentResponse.data = {
      ...state.homePageContentResponse.originalData,
    };
  }

  function setHomePageData(state, action) {
    const payload = action.payload;
    state.homePageContentResponse.data = payload;
    state.homePageContentResponse.originalData = JSON.parse(
      JSON.stringify(payload)
    );
  }
}

function createExtraActions() {
  const baseUrl = `${process.env.REACT_APP_API_URL}`;

  return {
    homePageContent: getHomePageContent(),
    updateHomePageIntegration: updateHomePageIntegration(),
    getTextEditorTemplate:getTextEditorTemplate()
  };

  function getHomePageContent() {
    return createAsyncThunk(
      `${name}/homePageContent`,
      async (loginForm) => await fetchWrapper.get(`${baseUrl}/home`)
    );
  }

  function updateHomePageIntegration() {
    return createAsyncThunk(
      `${name}/updateHomePageIntegration`,
      async (pageData) => await fetchWrapper.patch(`${baseUrl}/home`, pageData)
    );
  }

  function getTextEditorTemplate()
{
 return createAsyncThunk(
      `${name}/getTextEditorTemplate`,
      async (loginForm) => await fetchWrapper.get(`${baseUrl}/text-editor-template`)
    );
  }
}





function createExtraReducers(builder) {
  builder
    .addCase(extraActions.homePageContent.pending, (state) => {
      state.loading = true;
      state.error = null;
    })
    .addCase(extraActions.homePageContent.fulfilled, (state, action) => {
      state.homePageContentResponse = action.payload;
      state.loading = false;
    })
    .addCase(extraActions.homePageContent.rejected, (state, action) => {
      state.error = action.error;
      state.loading = false;
    })

    //update home page integration data
    .addCase(extraActions.updateHomePageIntegration.pending, (state) => {
      state.error = null;
      state.loading = true;
    })
    .addCase(
      extraActions.updateHomePageIntegration.fulfilled,
      (state, action) => {
        state.homePageIntegrationResponse = action.payload;
        state.loading = false;
      }
    )
    .addCase(
      extraActions.updateHomePageIntegration.rejected,
      (state, action) => {
        state.loading = false;
        state.error = action.error;
      }
    ).addCase(extraActions.getTextEditorTemplate.pending, (state) => {
      state.loading = true;
      state.error = null;
    })
    .addCase(extraActions.getTextEditorTemplate.fulfilled, (state, action) => {
      state.textEditorTemplate = action.payload;
      state.loading = false;
    })
    .addCase(extraActions.getTextEditorTemplate.rejected, (state, action) => {
      state.error = action.error;
      state.loading = false;
    });
}
